import {workdaysAdapter} from './adapters';
import {WorkdaysEntityState, WorkdayState} from './types';

export const initialState: WorkdayState = {
  workdays: <WorkdaysEntityState>workdaysAdapter.getInitialState(),
  isLoading: false,
};
